import { get, put, post } from "../utils/request";

const requestList = {
  getList: "/xxy/basic/defineColumn/list",
  getMenuList: "/uaa/menu/tree",
  getCustomMenu: "/xxy/sys/userMenu/list",
  savePassword: "/xxy/sys/user/resetPwd",
  saveBasicInfo: "/uaa/user/updatePassword",

  /* get_token */
  setLogin: "/uaa/form/pcToken",
  setLogout:'/uaa/user/logout',
  saveCustomMenu: "/xxy/sys/userMenu/save",
  addCustomMenu: "/xxy/sys/userMenu/add",
  deleteCustomMenu: "/xxy/sys/userMenu/delete",

  /*生产分析表头*/
  getMonthPlanCount: "/xxy/produce/analy/getMonthPlanCount",
  getMonthWorkCount: "/xxy/produce/analy/getMonthWorkCount",
  getDayWorkCont: "/xxy/produce/analy/getDayWorkCount",
  getDaySuccessCount: "/xxy/produce/analy/getDaySuccessCount",
  checkPermissions:'/xxy/report/api/checkPermissions',

  /* 免密登录  */
  setAutoAuth:'/uaa/form/aliIotToken',
  /* 页面图片  */
  getConfigList: "/xxy/resource/listLogo"
};

export function gets(type) {
  return async function(data, options) {
    return await get(requestList[type], data, options);
  };
}
export function posts(type) {
  return async function(data, options) {
    return await put(requestList[type], data, options);
  };
}
export function postsForm(type) {
  return async function(data, options) {
    return await post(requestList[type], data, options);
  };
}
